import { inject, Injectable } from '@angular/core';
import {
  MeetingAnalysisApiService,
  MeetingBotApiService,
  OverridePrivacyResponse,
  PrivacyLevel,
} from '@vendasta/meeting-analysis';
import { catchError, Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import {
  MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$,
  MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$,
} from '@galaxy/meeting-analysis/static';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Injectable({
  providedIn: 'root',
})
export class MeetingListService {
  readonly namespace$: Observable<string> = inject(MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$);
  readonly namespaceName$ = inject(MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$);

  readonly meetingAnalysisApiService = inject(MeetingAnalysisApiService);
  readonly meetingBotApiService = inject(MeetingBotApiService);
  readonly snackbarService = inject(SnackbarService);
  readonly dialog = inject(MatDialog);

  updateConversationVisibility(
    conversationId: string,
    namespace: string,
    newPrivacyLevel: PrivacyLevel,
  ): Observable<HttpResponse<null>> {
    if (!conversationId || !namespace || !newPrivacyLevel) {
      throw new Error('Conversation ID, namespace, or new privacy level is required');
    }
    return this.meetingAnalysisApiService
      .updateConversation({
        conversation: {
          id: conversationId,
          namespace: namespace,
          privacyLevel: newPrivacyLevel,
        },
        fieldMask: {
          paths: ['PrivacyLevel'],
        },
      })
      .pipe(
        catchError((error) => {
          console.error('Error updating conversation visibility', error);
          throw error;
        }),
      );
  }

  updateMeetingBotVisibility(meetingBotId: string, newPrivacyLevel: PrivacyLevel): Observable<OverridePrivacyResponse> {
    if (!meetingBotId || newPrivacyLevel === null) {
      throw new Error('Meeting bot ID or new privacy level is required');
    }
    return this.meetingBotApiService
      .overridePrivacy({
        meetingBotId: meetingBotId,
        privacyLevel: newPrivacyLevel,
      })
      .pipe(
        catchError((error) => {
          console.error('Error overriding privacy level', error);
          throw error;
        }),
      );
  }
}
